// Generated by CoffeeScript 2.7.0
var BasicCard, CollaboratorsCard, CommentsCard, MessageCards, PushesCard, ResponsesCard, TIME_FORMATTER;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import OrganizationSearch from 'trunks/vue/admin/components/search/organization.js';

import CollaboratorsSelect from 'trunks/vue/admin/compositions/collaborators_select.js';

import MessageGroupsSelect from 'trunks/vue/admin/compositions/message_groups_select.js';

import TagsSelect from 'trunks/vue/admin/compositions/tags_select.js';

TIME_FORMATTER = 'YYYY-MM-DD hh:mm';

CommentsCard = class CommentsCard {
  constructor(element1) {
    this.element = element1;
    this.element = DomMaster.wrap(this.element);
    new Skylark.Elements.DropdownSelect(this.element.find('.comment-setting-dropdown-select'), function(item_el, dropdown_select) {
      if (item_el != null ? item_el.isPresent() : void 0) {
        return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/comments`, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'script',
          data: {
            [`${$currentController.messageType}`]: {
              comment_status: dropdown_select.value
            }
          }
        });
      }
    });
  }

};

BasicCard = class BasicCard {
  constructor(element1) {
    var message_group_ids_str, tag_ids_str;
    this.element = element1;
    this.element = DomMaster.wrap(this.element);
    this.tags_popover_el = this.element.find('.tags-popover');
    if (this.tag_ids == null) {
      this.tag_ids = _.isString(tag_ids_str = this.element.data('tag-ids')) ? _.compact(_.map(tag_ids_str.split(','), function(id) {
        return parseInt(id);
      })) : [];
    }
    this.message_groups_popover_el = this.element.find('.message-groups-popover');
    if (this.message_group_ids == null) {
      this.message_group_ids = _.isString(message_group_ids_str = this.element.data('message-group-ids')) ? _.compact(_.map(message_group_ids_str.split(','), function(id) {
        return parseInt(id);
      })) : [];
    }
    this.element.node.proxy('click', '.js-tag-btn', () => {
      if (this.tags_popover == null) {
        this.tags_popover = new Skylark.Elements.Popover(this.tags_popover_el, {
          size: 'default',
          type: 'select',
          beforeOpenFunc: (popover) => {
            if (this.tag_select) {
              return this.tag_select.reset();
            } else {
              this.tag_select = new TagsSelect({
                el: this.element.find('.tags-edit-container').node,
                propsData: {
                  initialSelectedTagIds: this.tag_ids
                }
              });
              return this.tag_select.$on('optionsChanged', function() {
                return popover.__calculatePosition();
              }).$on('cancelClicked', () => {
                return this.tags_popover.close();
              }).$on('submitClicked', function(value) {
                return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/basic`, {
                  contentType: 'application/json; charset=utf-8',
                  responseType: 'script',
                  data: {
                    [`${$currentController.messageType}`]: {
                      tag_ids: value
                    }
                  },
                  success: function() {
                    return newAlertify('更新成功', {
                      type: 'success'
                    });
                  }
                });
              });
            }
          }
        });
      }
      return this.tags_popover.open();
    });
    this.element.node.proxy('click', '.js-message-group-btn', (event) => {
      if (this.groups_popover == null) {
        this.groups_popover = new Skylark.Elements.Popover(this.message_groups_popover_el, {
          size: 'default',
          type: 'select',
          beforeOpenFunc: (popover) => {
            if (this.message_group_select) {
              return this.message_group_select.reset();
            } else {
              this.message_group_select = new MessageGroupsSelect({
                el: this.element.find('.message-groups-edit-container').node,
                propsData: {
                  initialSelectedMessageGroupIds: this.message_group_ids
                }
              });
              return this.message_group_select.$on('optionsChanged', function() {
                return popover.__calculatePosition();
              }).$on('cancelClicked', () => {
                return this.groups_popover.close();
              }).$on('submitClicked', function(value) {
                return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/basic`, {
                  contentType: 'application/json; charset=utf-8',
                  responseType: 'script',
                  data: {
                    [`${$currentController.messageType}`]: {
                      message_group_ids: value
                    }
                  },
                  success: function() {
                    return newAlertify('更新成功', {
                      type: 'success'
                    });
                  }
                });
              });
            }
          }
        });
      }
      return this.groups_popover.open();
    });
  }

};

CollaboratorsCard = class CollaboratorsCard {
  constructor(element1) {
    var collaborator_ids_str;
    this.element = element1;
    this.element = DomMaster.wrap(this.element);
    this.collaborators_popover_el = this.element.find('.collaborators-popover');
    if (this.collaborator_ids == null) {
      this.collaborator_ids = _.isString(collaborator_ids_str = this.element.data('collaborator-ids')) ? _.compact(_.map(collaborator_ids_str.split(','), function(id) {
        return parseInt(id);
      })) : [];
    }
    this.element.node.proxy('click', '.js-collaborator-btn', (event) => {
      if (this.collaborators_popover == null) {
        this.collaborators_popover = new Skylark.Elements.Popover(this.collaborators_popover_el, {
          size: 'default',
          type: 'select',
          beforeOpenFunc: (popover) => {
            if (this.collaborators_select) {
              return this.collaborators_select.reset();
            } else {
              this.collaborators_select = new CollaboratorsSelect({
                el: this.element.find('.collaborators-edit-container').node,
                propsData: {
                  initialSelectedCollaboratorIds: this.collaborator_ids
                }
              });
              return this.collaborators_select.$on('optionsChanged', function() {
                return popover.__calculatePosition();
              }).$on('cancelClicked', () => {
                return this.collaborators_popover.close();
              }).$on('submitClicked', function(value) {
                return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/collaborators`, {
                  contentType: 'application/json; charset=utf-8',
                  responseType: 'script',
                  data: {
                    [`${$currentController.messageType}`]: {
                      collaborator_ids: value
                    }
                  }
                });
              });
            }
          }
        });
      }
      return this.collaborators_popover.open();
    });
  }

};

ResponsesCard = class ResponsesCard {
  constructor(element1) {
    var datetime_picker_input_el, initValue, popover_options;
    this.element = element1;
    this.element = DomMaster.wrap(this.element);
    this.element.node.proxy('change', '.js-responseable-status-switch', (event) => {
      return this._update({
        status: event._target.checked ? 'published' : 'closed'
      });
    });
    new Skylark.Elements.PromptPopover(this.element.find('.responses-limit-popover'), {
      size: 'normal',
      confirmFunc: (popover, value) => {
        var int_value;
        int_value = parseInt(value);
        return this._update({
          responses_limit: _.isNumber(int_value) ? int_value : null
        });
      }
    });
    datetime_picker_input_el = this.element.find('.js-closed-at-datetime-picker-input');
    popover_options = {
      limitStart: new Date(),
      ensureCallback: (value) => {
        var _strftime;
        _strftime = value != null ? value.strftime(TIME_FORMATTER) : void 0;
        datetime_picker_input_el.node.value = _strftime;
        return this._update({
          closed_at: _strftime
        });
      }
    };
    initValue = datetime_picker_input_el.node.value;
    _.extend(popover_options, {
      initValue: initValue
    });
    new Skylark.Elements.DatetimePickerPopover(this.element.find('.js-closed-at-datetimepicker-popover'), popover_options);
  }

  _update(data) {
    return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/responses`, {
      contentType: 'application/json; charset=utf-8',
      responseType: 'script',
      data: {
        [`${$currentController.messageType}`]: data
      }
    });
  }

};

PushesCard = class PushesCard {
  constructor(element1) {
    this.element = element1;
    this.element = DomMaster.wrap(this.element);
    this.response_subscription_settable = this.element.find('.js-response-subscription').isPresent();
    new Skylark.Elements.PromptPopover(this.element.find('.pushes-settings-popover'), {
      size: 'larger',
      type: 'prompt',
      beforeOpenFunc: () => {
        if (this.response_subscription_settable) {
          this.__initResponseSubscription();
          return this.__resetAt();
        }
      }
    });
    if (this.response_subscription_settable) {
      this.__initResponseSubscription();
    }
    this.__initChangeType();
    if (this.response_subscription_settable) {
      this.__initInterval();
      this.__initAt();
    }
  }

  __initResponseSubscription() {
    this.response_subscription_settings_el = this.element.find('.response-subscription-settings');
    this.response_subscription_settings_el.toggle(this.element.find('.js-response-subscription-check-box').node.checked);
    return this.element.node.proxy('click', '.js-response-subscription-check-box', (event) => {
      return this.response_subscription_settings_el.toggle(event._target.checked);
    });
  }

  __initChangeType() {
    return this.element.node.proxy('change', '.js-push-type', (event) => {
      return this.__findPushValueInput(event._target).node.checked = true;
    });
  }

  __initInterval() {
    var interval_push_value_el, push_value, push_value_unit_dropdown_select;
    interval_push_value_el = this.element.find('.js-interval-push-value');
    push_value_unit_dropdown_select = new Skylark.Elements.DropdownSelect(this.element.find('.push-value-unit-dropdown-select'), () => {
      this.__findPushValueInput(interval_push_value_el).node.value = push_value();
      return this.__checkPushTypeRadio(interval_push_value_el);
    });
    push_value = function() {
      return `${interval_push_value_el.node.value}${push_value_unit_dropdown_select.value}`;
    };
    return interval_push_value_el.node.proxy('input', () => {
      this.__findPushValueInput(interval_push_value_el).node.value = push_value();
      return this.__checkPushTypeRadio(interval_push_value_el);
    });
  }

  __initAt() {
    var datetime_picker_input_el, initValue, popover_options;
    datetime_picker_input_el = this.element.find('.js-at-datetime-picker-input');
    popover_options = {
      limitStart: new Date(),
      ensureCallback: (value) => {
        var _strftime;
        _strftime = value != null ? value.strftime(TIME_FORMATTER) : void 0;
        datetime_picker_input_el.node.value = _strftime;
        this.__findPushValueInput(datetime_picker_input_el).node.value = _strftime;
        return this.__checkPushTypeRadio(datetime_picker_input_el);
      }
    };
    initValue = datetime_picker_input_el.node.value;
    _.extend(popover_options, {
      initValue: initValue
    });
    return this.atDatetimePickerPopover = new Skylark.Elements.DatetimePickerPopover(this.element.find('.js-at-datetimepicker-popover'), popover_options);
  }

  __resetAt() {
    return this.atDatetimePickerPopover.reset();
  }

  __findPushValueInput(node) {
    return DomMaster.wrap(node).closest('.option-item').find('.js-push-value');
  }

  __checkPushTypeRadio(node) {
    this.__findPushValueInput(node).node.checked = true;
    return DomMaster.wrap(node).closest('.option-item').find('.js-push-type').node.checked = true;
  }

};

export default MessageCards = {
  _prepareCards: function() {
    this.cardsPatchUrl = `${location.pathname}/cards`;
    this._updateCommentsCard();
    this._updateBasicCard();
    this._updateCollaboratorsCard();
    return this._updatePushesCard();
  },
  _updateCommentsCard: function(content) {
    var ref, ref1;
    if ((ref = $currentController.commentsCard) != null) {
      if ((ref1 = ref.element.presence()) != null) {
        ref1.replaceWith(content);
      }
    }
    return $currentController.commentsCard = new CommentsCard(DomMaster.find('.js-comments-card'));
  },
  _updateBasicCard: function(content) {
    var ref, ref1;
    if ((ref = $currentController.basicCard) != null) {
      if ((ref1 = ref.element.presence()) != null) {
        ref1.replaceWith(content);
      }
    }
    return $currentController.basicCard = new BasicCard(DomMaster.find('.js-basic-card'));
  },
  _updateCollaboratorsCard: function(content) {
    var collaborators_card_el, ref, ref1;
    if ((ref = this.collaboratorsCard) != null) {
      if ((ref1 = ref.element.presence()) != null) {
        ref1.replaceWith(content);
      }
    }
    collaborators_card_el = DomMaster.find('.js-collaborators-card');
    if (collaborators_card_el.isPresent()) {
      return this.collaboratorsCard = new CollaboratorsCard(collaborators_card_el);
    }
  },
  _updateResponsesCard: function(content) {
    var ref, ref1;
    if ((ref = this.responsesCard) != null) {
      if ((ref1 = ref.element.presence()) != null) {
        ref1.replaceWith(content);
      }
    }
    return this.responsesCard = new ResponsesCard(DomMaster.find('.js-responses-card'));
  },
  _showActivitiesCard: function(content) {
    var modal_element;
    modal_element = Skylark.Elements.Modal.open(content, {
      modal_class_names: ['message-activities-modal']
    });
    return new Skylark.Elements.Pagination(modal_element.find('.pagination'));
  },
  _updatePushesCard: function(content) {
    var ref, ref1;
    if ((ref = this.pushesCard) != null) {
      if ((ref1 = ref.element.presence()) != null) {
        ref1.replaceWith(content);
      }
    }
    return this.pushesCard = new PushesCard(DomMaster.find('.js-pushes-card'));
  },
  _showBasicCard: function(content, global_id) {
    var element, message_group_ids, message_group_ids_str, modal_element, tag_ids, tag_ids_str;
    modal_element = Skylark.Elements.Modal.open(content, {
      modal_class_names: ['basic-modal'],
      beforeCloseFunc: function() {
        return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/basic`, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'script',
          data: {
            _sync: true
          }
        });
      }
    });
    _.each(modal_element.findAll('.hierarchical_select'), function(item) {
      var hierarchicalSelect, organization_ids;
      organization_ids = item.data('organization-ids').split(',');
      return hierarchicalSelect = new OrganizationSearch({
        el: item.node,
        propsData: {
          selectedOrganizationIds: organization_ids,
          remote: '/admin/organizations/query?enhanced=true',
          readonly: true
        }
      });
    });
    element = modal_element.find('.js-basic-modal');
    tag_ids = _.isString(tag_ids_str = element.data('tag-ids')) ? _.compact(_.map(tag_ids_str.split(','), function(id) {
      return parseInt(id);
    })) : [];
    message_group_ids = _.isString(message_group_ids_str = element.data('message-group-ids')) ? _.compact(_.map(message_group_ids_str.split(','), function(id) {
      return parseInt(id);
    })) : [];
    element.node.proxy('click', '.js-tag-btn', function(event) {
      var tags_popover;
      tags_popover = new Skylark.Elements.Popover(element.find('.tags-popover'), {
        size: 'default',
        type: 'select',
        beforeOpenFunc: function(popover) {
          var tag_select;
          tag_select = new TagsSelect({
            el: element.find('.tags-edit-container').node,
            propsData: {
              initialSelectedTagIds: tag_ids
            }
          });
          return tag_select.$on('optionsChanged', function() {
            return popover.__calculatePosition();
          }).$on('cancelClicked', function() {
            return tags_popover.close();
          }).$on('submitClicked', function(value) {
            return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/basic`, {
              contentType: 'application/json; charset=utf-8',
              responseType: 'script',
              data: {
                way: 'modal',
                [`${$currentController.messageType}`]: {
                  tag_ids: value
                }
              }
            });
          });
        }
      });
      return tags_popover.open();
    });
    return element.node.proxy('click', '.js-message-group-btn', function(event) {
      var groups_popover;
      groups_popover = new Skylark.Elements.Popover(element.find('.message-groups-popover'), {
        size: 'default',
        type: 'select',
        beforeOpenFunc: function(popover) {
          var message_group_select;
          message_group_select = new MessageGroupsSelect({
            el: element.find('.message-groups-edit-container').node,
            propsData: {
              initialSelectedMessageGroupIds: message_group_ids
            }
          });
          return message_group_select.$on('optionsChanged', function() {
            return popover.__calculatePosition();
          }).$on('cancelClicked', function() {
            return groups_popover.close();
          }).$on('submitClicked', function(value) {
            return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/basic`, {
              contentType: 'application/json; charset=utf-8',
              responseType: 'script',
              data: {
                way: 'modal',
                [`${$currentController.messageType}`]: {
                  message_group_ids: value
                }
              }
            });
          });
        }
      });
      return groups_popover.open();
    });
  },
  _showAppendUserBoundaryCard: function(content, global_id) {
    var append_ub_el, modal_element, ub_vm;
    modal_element = Skylark.Elements.Modal.open(content, {
      modal_class_names: ['append-user-boundary-modal']
    });
    append_ub_el = modal_element.find('.js-append-user-boundary-select');
    ub_vm = new Skylark.Bridge.UserBoundary({
      propsData: {
        type: 'appended',
        calCountUrl: `${location.pathname}/receipts/append_counter`,
        userBoundary: {}
      },
      el: append_ub_el.node
    });
    return modal_element.node.proxy('click', '.js-append-user-boundary', function(event) {
      var data;
      data = ub_vm.getData();
      if (!data.user_ids.length && !data.organization_ids.length) {
        Skylark.Bridge.newAlertify('请设置追加范围', {
          type: 'error'
        });
        return;
      }
      if (data.user_tag_ids && !data.user_tag_ids.length) {
        Skylark.Bridge.newAlertify('请选择用户标签', {
          type: 'error'
        });
        return;
      }
      return Skylark.Libs.Ajax.post(`${location.pathname}/receipts/append`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'script',
        data: {
          user_boundary: data
        },
        success: function() {
          return Skylark.Elements.Modal.dismiss();
        }
      });
    });
  },
  _showReceiptsCard: function(content, global_id) {
    var gid, modal_element, receipts_card, url;
    modal_element = Skylark.Elements.Modal.open(content, {
      class_name: 'receipts-card-table-modal',
      modal_class_names: ['large-modal']
    });
    new Skylark.Elements.Pagination(modal_element.find('.pagination'));
    gid = new Skylark.Libs.GlobalID(global_id);
    url = Skylark.Helpers.UrlHelper.adminUrlFor(`${gid.toPath()}/cards/receipts`);
    receipts_card = new Skylark.Elements.MessageCards.Receipts(modal_element, gid, modal_element.find('.js-receipts-card-query-input input[type=text]').node.value);
    return new Skylark.Elements.BasicQueryInput(modal_element.find('.js-receipts-card-query-input'), {
      queryFunc: function(word) {
        return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.generateUrlWithParams(url, {
          states: receipts_card.selectedStates,
          name: word
        }), {
          responseType: 'script'
        });
      },
      cancelQueryFunc: function() {
        return Skylark.Libs.Ajax.get(Skylark.Helpers.UrlHelper.generateUrlWithParams(url, {
          states: receipts_card.selectedStates
        }), {
          responseType: 'script'
        });
      }
    });
  },
  _showCollaboratorsCard: function(content, global_id) {
    var collaborators_card, modal_element;
    modal_element = Skylark.Elements.Modal.open(content, {
      class_name: 'collaborators-card-table-modal',
      modal_class_names: ['large-modal'],
      beforeCloseFunc: function() {
        return Skylark.Libs.Ajax.patch(`${$currentController.cardsPatchUrl}/collaborators`, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'script',
          data: {
            _sync: true
          }
        });
      }
    });
    return collaborators_card = new Skylark.Elements.MessageCards.Collaborators(modal_element, global_id);
  },
  _showRedPacketsCard: function(content, global_id) {
    var modal_element;
    modal_element = Skylark.Elements.Modal.open(content, {
      class_name: 'red-packets-card-table-modal',
      modal_class_names: ['large-modal']
    });
    return new Skylark.Elements.MessageCards.RedPackets(modal_element);
  }
};
